import { format } from "date-fns";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { BsEnvelope, BsFillTelephoneFill } from "react-icons/bs";
import { IoCloseCircleOutline } from "react-icons/io5";
import orgApi from "../../../api/org_api";
import {
  Breadcrumb,
  CustomDatePicker,
  FooterButtons,
  FunnelIconButton,
  IconButton,
  Paragraph,
  Table,
  Text,
} from "../../../component/common";
import PaginationButtons from "../../../component/PaginationButtons";
import S from "../../../Services/GeneralServices";
import { getTz } from "../../../utils/CommonMethods";
import { sevenDaysAgo } from "../../../utils/constant";
import { cn } from "../../../utils/lib";

const TAReport = () => {
  const [schedule, setSchedule] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPost, setTotal] = useState(0);
  const [showStats, setShowStats] = useState(false);
  const [stats, setStats] = useState([] as any);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [dateFilter, setDateFilter] = useState<{
    from: Date | null;
    to: Date | null;
  }>({ from: sevenDaysAgo, to: new Date() });

  useEffect(() => {
    getSchedule(dateFilter.from, dateFilter.to);
  }, []);

  const handleFromDateChange = (date: Date | null) =>
    setDateFilter({ ...dateFilter, from: date });
  const handleToDateChange = (date: Date | null) =>
    setDateFilter({ ...dateFilter, to: date });
  const clearFilter = () => {
    setDateFilter({ from: sevenDaysAgo, to: new Date() });
    setShowFilter(false);
  };
  const getSchedule = async (from: Date | null, to: Date | null) => {
    const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
    const res = await orgApi.taReport(org.id, { from, to });
    setSchedule(res?.data?.org);
    setTotal(res?.data?.org?.length);
    const t = Math.ceil(res?.data?.org?.length / 10);
    setTotalPages(t);
  };

  const nextPage = async (org_id: any, status: any) => {
    setStats([]);
    const data = { status };
    const res = await orgApi.taReportSchedule(org_id, data);
    setStats(res?.data?.schedule);
    setSelectedStatus(status);
    setShowStats(true);
  };

  const getTableData = () => {
    const coloumns = [
      { label: "Recruiter Name", accessor: "name" },
      { label: "Profile", accessor: "setup" },
      { label: "Scheduled", accessor: "scheduled" },
      { label: "Rescheduled", accessor: "rescheduled" },
      { label: "Cancelled", accessor: "cancelled" },
      { label: "Completed", accessor: "completed" },
      { label: "Selected", accessor: "selected" },
      { label: "Rejected", accessor: "rejected" },
      { label: "No Show", accessor: "noshow" },
      { label: "Proxy", accessor: "proxy" },
      { label: "Profile vs Schedule", accessor: "profile_vs_schedule" },
      { label: "Profile vs Reschedule", accessor: "profile_vs_reschedule" },
      { label: "Schedule vs Completed", accessor: "schedule_vs_completed" },
      { label: "Completed vs Proxy", accessor: "completed_vs_proxy" },
      { label: "Completed vs No Show", accessor: "completed_vs_no_show" },
      { label: "Completed vs Selected", accessor: "completed_vs_selected" },
      { label: "Completed vs Rejected", accessor: "completed_vs_rejected" },
    ];

    const data =
      schedule &&
      schedule.length &&
      schedule.map((x: any, index: number) => {
        const completed = +x.completed + +x.selected + +x.rejected;
        const scheduled = +x.scheduled + completed;

        return {
          name: <Text key={index} text={x.rec_name ? x.rec_name : "-"} />,
          setup: <Text text={x.setup} />,
          scheduled: (
            <Text
              className={cn(
                "text-xs ",
                x.scheduled > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.scheduled > 0 && nextPage(x.org_id, "Scheduled")}
              text={scheduled || "0"}
            />
          ),
          rescheduled: (
            <Text
              className={cn(
                "text-xs ",
                x.rescheduled > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() =>
                x.rescheduled > 0 && nextPage(x.org_id, "Rescheduled")
              }
              text={x.rescheduled}
            />
          ),
          completed: (
            <Text
              className={cn(
                "text-xs ",
                x.completed > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.completed > 0 && nextPage(x.org_id, "Completed")}
              text={x.completed}
            />
          ),
          noshow: (
            <Text
              className={cn(
                "text-xs ",
                x.no_show > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.no_show > 0 && nextPage(x.org_id, "No Show")}
              text={x.no_show}
            />
          ),
          proxy: (
            <Text
              className={cn(
                "text-xs ",
                x.proxy > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.proxy > 0 && nextPage(x.org_id, "Proxy")}
              text={x.proxy}
            />
          ),
          rejected: (
            <Text
              className={cn(
                "text-xs ",
                x.rejected > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.rejected > 0 && nextPage(x.org_id, "Rejected")}
              text={x.rejected}
            />
          ),
          cancelled: (
            <Text
              className={cn(
                "text-xs ",
                x.cancelled > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.cancelled > 0 && nextPage(x.org_id, "Cancelled")}
              text={x.cancelled}
            />
          ),
          selected: (
            <Text
              className={cn(
                "text-xs ",
                x.selected > 0 &&
                  " cursor-pointer hover:text-blue-500  hover:font-semibold",
              )}
              onClick={() => x.selected > 0 && nextPage(x.org_id, "Selected")}
              text={x.selected}
            />
          ),
          profile_vs_schedule: calculatePercentage(scheduled, x.setup),
          profile_vs_reschedule: calculatePercentage(x.rescheduled, x.setup),
          schedule_vs_completed: calculatePercentage(completed, scheduled),
          completed_vs_proxy: calculatePercentage(x.proxy, completed),
          completed_vs_no_show: calculatePercentage(x.no_show, completed),
          completed_vs_selected: calculatePercentage(x.selected, completed),
          completed_vs_rejected: calculatePercentage(x.rejected, completed),
        };
      });
    return { coloumns, data };
  };

  const getDetialTableData = () => {
    const columns = [
      { label: "Candidate Details", accessor: "candidate_details" },
      { label: "Post Title", accessor: "post_title" },
      { label: "Round", accessor: "round" },
      { label: "Interviewer Name", accessor: "interviewer_name" },
      { label: "Interview Date", accessor: "interview_date" },
      { label: "Interview Time", accessor: "interview_time" },
    ];

    if (selectedStatus === "Completed") {
      columns.push({ label: "Status", accessor: "status" });
    }
    if (
      selectedStatus === "Completed" ||
      selectedStatus === "Rejected" ||
      selectedStatus === "Selected" ||
      selectedStatus === "Submitted" ||
      selectedStatus === "Offered"
    ) {
      if (S.getOrgDomain() !== "nam-it.com") {
        columns.push({ label: "SIT Score", accessor: "sit_score" });
      } else {
        columns.push({ label: "Feedback", accessor: "feedback" });
      }
    }
    if (selectedStatus === "No Show" || selectedStatus === "Proxy") {
      columns.push({ label: "Feedback", accessor: "feedback" });
    }
    if (
      selectedStatus === "Completed" ||
      selectedStatus === "Rejected" ||
      selectedStatus === "Selected" ||
      selectedStatus === "Submitted" ||
      selectedStatus === "Offered"
    ) {
      columns.push({ label: "Recommended", accessor: "recommended" });
    }
    const data =
      stats && stats.length > 0
        ? stats.map((value: any, s_index: number) => {
            const baseData: any = {
              candidate_details: (
                <div
                  key={s_index}
                  className=" flex flex-col items-start gap-1 truncate"
                >
                  <p className="font-semibold truncate">
                    {value.candidate.first_name} {value.candidate.last_name}
                  </p>
                  <p className="flex flex-row items-center gap-1 truncate">
                    <BsEnvelope /> &nbsp;
                    <span>{value.candidate.email}</span>
                  </p>
                  <p className="flex flex-row items-center gap-1">
                    <BsFillTelephoneFill /> &nbsp;
                    {value.candidate.mobile}
                  </p>
                </div>
              ),
              post_title: (
                <p className="p-2 truncate">{value.post.job_title}</p>
              ),
              round: <p className="p-2">{value.level}</p>,
              interviewer_name: (
                <p className="p-2 truncate">
                  {value.interviewer?.candidate.first_name || ""}{" "}
                  {value.interviewer?.candidate.last_name || ""}
                </p>
              ),
              interview_date: (
                <p className="p-2">
                  {format(value.utc_starttime, "dd MMM yyyy")}
                </p>
              ),
              interview_time: value.utc_endtime ? (
                <p className="p-2">
                  {format(value.utc_starttime, "hh:mm a")} to{" "}
                  {format(value.utc_endtime, "hh:mm a")}{" "}
                  {getTz(value.candidate_tz)}
                </p>
              ) : null,
            };

            if (selectedStatus === "Completed") {
              baseData.status = (
                <p className="p-2">
                  {value.status === "Completed" &&
                  value.feedback_status === "Completed" &&
                  value.feedback.length > 0 &&
                  value.feedback[0].interview_status !== "Completed"
                    ? value.feedback[0].interview_status
                    : value.status === "NR"
                      ? "Next Round"
                      : value.status}
                </p>
              );
            }

            if (
              selectedStatus === "Completed" ||
              selectedStatus === "Rejected" ||
              selectedStatus === "Selected" ||
              selectedStatus === "Submitted" ||
              selectedStatus === "Offered"
            ) {
              if (value.feedback_status === "Completed") {
                if (S.getOrgDomain() !== "nam-it.com") {
                  baseData.sit_score = (
                    <p
                      className="p-2 text-xs 2xl:text-md cursor-pointer hover:text-blue-500 hover:font-semibold"
                      onClick={() =>
                        value.feedback.length > 0
                          ? S.viewFeedback(value.id)
                          : window.open(value.feedback_url)
                      }
                    >
                      {value.feedback.length > 0
                        ? value.feedback[0].sit_score
                        : value.sit}
                    </p>
                  );
                } else {
                  baseData.feedback = (
                    <p
                      className="p-2 text-xs 2xl:text-md cursor-pointer hover:text-blue-500 hover:font-semibold"
                      onClick={() =>
                        value.feedback.length > 0
                          ? S.viewFeedback(value.id)
                          : window.open(value.feedback_url)
                      }
                    >
                      <span className="underline text-blue-500">Link</span>
                    </p>
                  );
                }
              } else {
                if (S.getOrgDomain() !== "nam-it.com") {
                  baseData.sit_score = <p className="p-2">-</p>;
                } else {
                  baseData.feedback = <p className="p-2">-</p>;
                }
              }
            }

            if (selectedStatus === "No Show" || selectedStatus === "Proxy") {
              baseData.feedback = (
                <p
                  className="p-2 text-xs 2xl:text-md cursor-pointer text-primary font-semibold"
                  onClick={() => S.viewFeedback(value.id)}
                >
                  View Feedback
                </p>
              );
            }

            if (
              selectedStatus === "Completed" ||
              selectedStatus === "Rejected" ||
              selectedStatus === "Selected" ||
              selectedStatus === "Submitted" ||
              selectedStatus === "Offered"
            ) {
              baseData.recommended = (
                <p className="p-2">
                  {value.feedback_status === "Completed" &&
                  value.feedback.length > 0 &&
                  value.feedback[0].interview_status === "Completed"
                    ? S.getOrgDomain() !== "nam-it.com"
                      ? value.feedback[0].recommended_status
                      : value.feedback[0].eligible_for_this_position
                        ? "Yes"
                        : "No"
                    : "-"}
                </p>
              );
            }

            return baseData;
          })
        : [];

    return { columns, data };
  };

  return (
    <div className="h-[calc(100vh-100px)] w-[calc(100vw-120px)] 2xl:w-[calc(100vw-155px)] 2xl:h-[calc(100vh-115px)]">
      {!showStats ? (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Breadcrumb
              items={[
                { text: "Reports", href: "/report_list" },
                { text: `TA Report (${totalPost})`, isActive: true },
              ]}
            />
            <FunnelIconButton
              className="p-2"
              onClick={() => setShowFilter(!showFilter)}
              active={!!dateFilter.from || !!dateFilter.to}
            />
            <AnimatePresence>
              {showFilter && (
                <motion.div
                  initial={{ opacity: 0, y: -10, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -10, scale: 0.95 }}
                  transition={{ duration: 0.2 }}
                  className="absolute right-6 top-[110px] z-20 w-60 rounded-lg border border-gray-200 bg-white p-3 shadow-lg 2xl:w-72 2xl:p-4"
                >
                  <div className="space-y-2 2xl:space-y-2.5">
                    <div className="flex items-center justify-between gap-2">
                      <Paragraph text="Filter" color="text-gray-500" />
                      <IconButton
                        icon={
                          <IoCloseCircleOutline className="h-3.5 w-3.5 2xl:h-4 2xl:w-4" />
                        }
                        onClick={() => {
                          clearFilter();
                          setShowFilter(false);
                        }}
                        color="red"
                        className="-my-1 -mr-1 p-1"
                      />
                    </div>
                    <div className="space-y-2">
                      <CustomDatePicker
                        label="Start Date"
                        selected={dateFilter.from}
                        onBlur={() =>
                          dateFilter.from
                            ? handleFromDateChange(dateFilter.from)
                            : handleFromDateChange(new Date())
                        }
                        onChange={(date) => handleFromDateChange(date)}
                        showYearDropdown
                        showMonthDropdown
                        maxDate={dateFilter.to || new Date()}
                      />
                      <CustomDatePicker
                        label="End Date"
                        selected={dateFilter.to}
                        onBlur={() =>
                          dateFilter.to
                            ? handleToDateChange(dateFilter.to)
                            : handleToDateChange(new Date())
                        }
                        onChange={(date) => handleToDateChange(date)}
                        minDate={dateFilter.from || undefined}
                        showYearDropdown
                        showMonthDropdown
                        maxDate={new Date()}
                      />
                    </div>
                    <FooterButtons
                      primaryOnClick={() => {
                        setShowFilter(false);
                        getSchedule(dateFilter.from, dateFilter.to);
                      }}
                      secondaryOnClick={() => {
                        setDateFilter({ from: sevenDaysAgo, to: new Date() });
                      }}
                      primaryText="Apply"
                      secondaryText="Reset"
                    />
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div>
            <Table
              columns={getTableData().coloumns}
              data={getTableData().data}
              containerHeight="h-[calc(100vh-205.5px)]"
              isStickyHeader
            />
          </div>
          {totalPost > 10 && (
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      ) : (
        <div className="h-[calc(100vh-100px)] flex flex-col space-y-4">
          <Breadcrumb
            items={[
              { text: "TA Report", onClick: () => setShowStats(false) },
              { text: `${selectedStatus} (${stats.length})`, isActive: true },
            ]}
          />
          <Table
            columns={getDetialTableData().columns}
            data={getDetialTableData().data}
            containerHeight="h-[calc(100vh-160px)]"
            isStickyHeader
          />
        </div>
      )}
    </div>
  );
};
export default TAReport;

export const calculatePercentage = (value: number, total: number): string => {
  if (total === 0) return "0%";
  return `${Math.round((value / total) * 100)}%`;
};
